const popOverlay = require('./pop-overlay.js');

/**
 * Inits popIn (modal popup window) for elements
 *
 * @param selector jquery selector for elements for which popIn is initialized
 */
function popIn(selector) {
  $(selector).each(function each() {
    const trigger = $(this);
    const rel = $(trigger.attr('href'));
    trigger.click((e) => {
      e.preventDefault();
      popOverlay.createPopOverlay(rel);
    });
  });
}

module.exports = {
  initPopInForElements: function(elt) {
    popIn(elt);
  }
};
